<!--  -->
<template>
  <div class="training-head">
    <!-- 网站标题 -->
    <h1 class="head-title" @click="exitProject('home')">
      <img :src="Logo.img" alt="AI-training" class="head-title-img" />
    </h1>
    <div class="head-left">
      <div class="menu-list">
        <div class="head-item head-file">
          <el-dropdown
            class="head-file-dropdown"
            placement="bottom"
            @command="headFileCommand"
            :tabindex="tabindex_1"
          >
            <span class="el-dropdown-link">
              <i
                :class="['icon_box', !projectId ? 'un-active' : '']"
                style="color:#fff;transform:scale(1.3)"
              >
                <icon-base
                  class="icon_nav-icon"
                  :icon-name="Icons.NavFile.iconName"
                  v-bind="Icons.NavFile"
                >
                  <icon-nav-file />
                </icon-base>
              </i>
              文件
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="activeOpenPopup"
                >打开</el-dropdown-item
              >
              <el-dropdown-item command="activeCreatePopup"
                >新建</el-dropdown-item
              >
              <el-dropdown-item
                command="activeSaveCopyPopup"
                :disabled="!projectId"
                :class="[!projectId ? 'un-active' : '']"
                >另存为</el-dropdown-item
              >
              <el-dropdown-item
                command="activeProjectCase"
                :disabled="!projectId"
                :class="[!projectId ? 'un-active' : '']"
                >项目案例</el-dropdown-item
              >
              <el-dropdown-item
                command="saveToLocal"
                :disabled="!projectId"
                :class="[!projectId ? 'un-active' : '']"
                >保存到本地</el-dropdown-item
              >
              <el-dropdown-item
                command="openFromLocal"
                :disabled="!projectId"
                :class="[!projectId ? 'un-active' : '']"
                >从本地打开</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="func-wrap">
          <el-button
            class="head-item head-save"
            @click="saveFile"
            :class="{
              disPermit:
                (userId !== Project.createBy && Project.proOperate === 1) ||
                !projectId,
            }"
          >
            <img :src="saveProjectIcon" alt="" class="icon-del-head" />
            <span class="text">保存</span>
          </el-button>
        </div>

        <div>
          <el-button class="head-item head-exit" @click="exitProject('back')">
            <img :src="exitProjectIcon" alt="" class="icon-publish-head" />
            <span class="text">退出</span>
          </el-button>
        </div>
      </div>
      <!-- 头部编辑操作 -->
      <div class="head-edite-operate">
        <div class="training-name">
          <el-input
            v-model.trim="Project.projectName"
            placeholder="请输入实训项目名称"
            @change="editeProject"
            maxlength="20"
          ></el-input>
        </div>
        <div class="training-switch">
          <el-button
            :class="workspaceIsVisible ? 'switch-on' : 'switch-off'"
            @click="changeMode"
          >
            <i class="icon_box">
              <icon-base
                class="icon_mode-code"
                :icon-name="Icons.ModeCode.iconName"
                v-bind="Icons.ModeCode"
              >
                <icon-mode-code />
              </icon-base>
            </i>
            <span>代码模式</span>
          </el-button>

          <el-button
            :class="workspaceIsVisible ? 'switch-off' : 'switch-on'"
            @click="changeMode"
          >
            <i class="icon_box">
              <icon-base
                class="icon_mode-code"
                :icon-name="Icons.ModeCode.iconName"
                v-bind="Icons.ModeCode"
              >
                <icon-mode-code />
              </icon-base>
            </i>
            <span>积木模式</span>
          </el-button>
        </div>
        <!-- 帮助文档入口 -->
        <div class="help" @click="toDocPage">
          <icon-base
            class="help-icon"
            :icon-name="Icons.HeadHelp.iconName"
            v-bind="Icons.HeadHelp"
          >
            <icon-head-help />
          </icon-base>
        </div>
      </div>
    </div>

    <div class="head-right">
      <!-- TODO:分割线 -->
      <span class="col-line"></span>
      <div class="userinfo">
        <div class="profile">
          <img
            :src="
              accountInfo.photo
                ? /^(https?:\/\/)/.test(accountInfo.photo)
                  ? accountInfo.photo
                  : photoBaseUrl + accountInfo.photo
                : profile
            "
            alt
          />
        </div>
             <span class="el-dropdown-link header-name ellipsis" :title="accountInfo.realName">
          {{ accountInfo.realName }}
        </span>
        <span class="el-dropdown-link user-role">
          <!-- {{ accountInfo.userTenantRoleList[0].roleName }} -->
          {{ accountInfo.roleName }}
        </span>
        <!--        <div class="profile-menu" v-show="hasLogin">-->
        <!--          <ul>-->
        <!--            <li @click="JumpPersonal">个人空间</li>-->
        <!--            <li @click="JumpSetting">账号设置</li>-->
        <!--            <li @click="quitLogin">退出登录</li>-->
        <!--          </ul>-->
        <!--        </div>-->
      </div>
    </div>
    <!-- </div> -->
    <div class="popup-list">
      <!-- 打开项目 -->
      <gat-popup
        :class="[
          'popup-open',
          popupActive === 'openCreate' ? 'popup-open-create' : '',
          popupActive === 'openCreate' || popupActive === 'open' ? 'on' : 'off',
        ]"
        @cancel="cancelPopup"
      >
        <template v-slot:head>
          <nav class="open-tab-nav">
            <span
              :class="[
                'open-tab',
                popupTabName === 'myProjects' ? 'active' : '',
              ]"
              @click="onPopupTabName('myProjects')"
              >我的项目</span
            >
            <span
              v-if="popupActive === 'openCreate'"
              :class="[
                'open-tab',
                popupTabName === 'newProjects' ? 'active' : '',
              ]"
              @click="onPopupTabName('newProjects')"
              >新建项目</span
            >
            <!-- TODO:暂时无项目数据 -->
            <span class="open-tab active" v-if="false">课程项目</span>
          </nav>
        </template>
        <template v-slot:content>
          <div class="open-content">
            <div v-if="popupTabName === 'myProjects'">
              <el-input
                class="open-content-search"
                v-model.trim="searchKey"
                placeholder="请输入项目名称"
                @keyup.enter.native="GetPageListByName"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="GetPageListByName"
                ></i>
              </el-input>
              <ul class="open-projects">
                <li class="open-projects-tips" v-if="projectList.records && projectList.records.length === 0">
                  <img :src="emptyImgUrl" alt="">
                  <span>{{searchKey ? '未检索到符合条件的项目' : '当前无项目'}}</span>
                </li>
                <li
                  class="open-project"
                  v-for="(item, idx) in projectList.records"
                  :key="item.projectId || idx"
                  @click="activeSelectProject(item)"
                >
                  <img class="cover" :src="Category.img01" alt />
                  <span class="title ellipsis" :title="item.projectName">{{ item.projectName }}</span>
                  <span class="dt-edit">
                    {{
                      item.editTime || item.createTime | moment('YYYY.MM.DD')
                    }}
                  </span>
                </li>
              </ul>
              <!-- 分页 -->
              <!-- <div
                class="pagination"
                :style="popupActive === 'openCreate' ? 'padding: 10px 0' : ''"
              > -->
              <el-pagination
                v-if="projectList.records && projectList.records.length !== 0"
                @current-change="handleCurrentChange"
                background
                :current-page.sync="currentPage"
                :page-size="popupActive === 'openCreate' ? 4 : 6"
                :pager-count="5"
                layout="slot, prev, pager, next"
                :total="totalCount"
              ></el-pagination>
              <!-- </div> -->
            </div>
            <!-- 分割线 -->
            <!-- <el-divider v-if="popupActive === 'openCreate'"></el-divider> -->
            <!-- 新建项目 -->
            <div
              v-if="
                popupTabName === 'newProjects' && popupActive === 'openCreate'
              "
            >
              <el-form
                class="pop-el-form"
                :model="NewProject"
                :rules="rules"
                ref="popupUploadForm"
              >
                <el-form-item prop="projectName">
                  <el-input
                    placeholder="项目名称，必填项"
                    v-model.trim="NewProject.projectName"
                    maxlength="20"
                    show-word-limit
                  />
                </el-form-item>
                <el-form-item prop="proType">
                  <el-select
                    class="pop-select"
                    v-model="NewProject.proType"
                    placeholder="请选择项目类型，必填项"
                    filterable
                  >
                    <el-option
                      v-for="item in projectTypeArr"
                      :key="item.dictId"
                      :label="item.dictTypeDesc"
                      :value="item.dictId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="projectContent">
                  <el-input
                    class="pop-textarea"
                    type="textarea"
                    :rows="3"
                    maxlength="200"
                    placeholder="项目描述，必填项"
                    v-model.trim="NewProject.projectContent"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item class="el-form-item-button">
                  <el-button
                    class="createButtom"
                    type="primary"
                    @click="onOpenCreate"
                    >新建</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <template v-slot:buttons>
          <span></span>
        </template>
      </gat-popup>

      <!-- 新建项目 、另存为弹框-->
      <gat-popup
        :class="[
          'popup-create',
          popupActive === 'create' || popupActive === 'copy' ? 'on' : 'off',
        ]"
        :title="popupActive === 'create' ? '新建项目' : '项目另存为'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="projectHandler"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewProject"
            :rules="rules"
            ref="popupUploadForm"
          >
            <el-form-item prop="projectName">
              <el-input
                placeholder="项目名称，必填项"
                v-model.trim="NewProject.projectName"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
            <el-form-item prop="proType">
              <el-select
                class="pop-select"
                v-model="NewProject.proType"
                placeholder="请选择项目类型，必填项"
                filterable
              >
                <el-option
                  v-for="item in projectTypeArr"
                  :key="item.dictId"
                  :label="item.dictTypeDesc"
                  :value="item.dictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="projectContent">
              <el-input
                class="pop-textarea"
                type="textarea"
                :rows="5"
                maxlength="200"
                placeholder="项目描述，必填项"
                v-model.trim="NewProject.projectContent"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
      <!-- 项目案例 -->
      <gat-popup
        :class="['popup-case', popupActive === 'case' ? 'on' : 'off']"
        :title="'项目案例'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <!-- <ul class="cases">

              <li
                class="case-item"
                v-for="(item, idx) in Cases.records"
                :key="idx"
                @click="caseToWorkspace(idx)"
              >
                <div class="cover">

                  <img :src="item.Cover" alt />
                </div>
                <div class="info">
                  <h3 class="title ellipsis">{{ item.CaseName }}</h3>
                  <dl class="rate">
                    <dt class="p-rate">难度：</dt>
                    <dd>
                      <i
                        :class="[
                          'icon-star',
                          UIRatingStarshow(idx, item.Difficulty)
                        ]"
                        v-for="(star, idx) in Array(5)"
                        :key="idx"
                      ></i>
                    </dd>
                  </dl>
                </div>
              </li>
            </ul> -->
          <ul class="open-projects">
            <li class="open-projects-tips" v-if="Cases.records&&Cases.records.length === 0">
              <img :src="emptyImgUrl" alt="">
              <span>暂无公开项目案例哦~</span>
            </li>
            <li
              class="open-project"
              v-for="(item, idx) in Cases.records"
              :key="item.projectId || idx"
              @click="activeSelectProject(item)"
            >
              <img class="cover" :src="Category.img01" alt />
              <span class="title ellipsis" :title="item.projectName">{{ item.projectName }}</span>
              <span class="dt-edit">
                {{ item.editTime || item.createTime | moment('YYYY.MM.DD') }}
              </span>
            </li>
          </ul>
          <el-pagination
            v-if="Cases.records&&Cases.records.length !== 0"
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="6"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </template>
        <template v-slot:buttons>
          <span></span>
        </template>
      </gat-popup>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// 图标
import IconNavFile from '@/components/icons/typography/IconNavFile'
import IconNavSave from '@/components/icons/typography/IconNavSave'
import IconModeCode from '@/components/icons/typography/IconModeCode'
import IconHeadHelp from '@/components/icons/typography/HeadHelp'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
// import IconUndoOrRedo from "@/components/icons/typography/UndoOrRedo";
// import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import GatPopup from '@/components/common/GatPopup'
import { DictType } from '@/assets/js/mixin/mixin.js'
import bus from '@/utils/bus'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'HardwareEditorHead',
  inject: ['reload'],
  mixins: [DictType],
  components: {
    IconNavFile,
    // IconNavSave,
    // IconInfoHelp,
    IconModeCode,
    IconHeadHelp,
    GatPopup,
  },
  props: ['projectId', 'trainingId', 'Project', 'editorId'],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      hasLogin: null,
      popupTabName: 'myProjects', // 弹窗tab: newProjects(新建项目),myProjects(我的项目)
      TrainId: '',
      popupActive: '',
      buildingBlocksType: {
        //积木类型
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      Logo: {
        img: require('../../../../../public/images/logo.png'),
      },
      tabindex_1: 1,
      tabindex_2: 2,
      // workspace visible
      workspaceIsVisible: true,
      profile: require('../../../../../public/images/profile03.png'),
      User: {
        profile: require('../../../../../public/images/profile03.png'),
        UserName: '',
      },
      Icons: {
        NavFile: {
          iconName: '文件',
          viewBox: '0 0 19 18',
          width: '19',
          height: '18',
          iconColor: '#fff',
        },
        NavSave: {
          iconName: '保存',
          viewBox: '0 0 18 19',
          width: '18',
          height: '19',
          iconColor: '#fff',
        },
        ModeCode: {
          iconName: '代码模式',
          viewBox: '0 0 16 15',
          width: '16',
          height: '15',
          iconColor: '#5883ff',
        },
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
        HeadHelp: {
          iconName: '使用文档',
          viewBox: '0 0 24 24',
          width: '24',
          height: '24',
          iconColor: '#fff',
        },
      },
      projectList: {
        records: [
          // {
          //   projectId: '0',
          //   projectName: 'AI 人形机器人',
          //   blocksFileUrl: '',
          //   projectContent: '',
          //   proType: '',
          //   proTypeName: '',
          //   isCollect: true,
          // },
        ],
        size: 6,
        current: 1,
        total: 0,
      },
      Cases: {
        records: [
          // {
          //   projectId: '0',
          //   projectName: 'AI 人形机器人',
          //   blocksFileUrl: '',
          //   projectContent: '',
          //   proType: '',
          //   proTypeName: '',
          //   isCollect: true,
          // },
        ],
        size: 6,
        current: 1,
        total: 0,
      },

      proOperate: 0, //0个人 1公开;
      currentPage: 1,
      searchKey: '', // 自然状态
      pageStatus: 'normal', // normal 正常获取，search 搜索状态
      NewProject: {
        projectId: '0',
        projectName: '',
        projectContent: '',
        proType: '',
        proTypeName: '',
      },
      rules: {
        projectName: [{ required: true, message: '请填写项目名称' }],
        projectContent: [{ required: true, message: '请填写项目描述内容' }],
        proType: [{ required: true, message: '请选择项目类型' }],
      },
      pageStutas: 'normal',
      Category: {
        img01: require('../../../../../public/images/img01.png'),
        img02: require('../../../../../public/images/img02.png'),
      },
      saveProjectIcon: require('@/assets/images/ai-editor/icon-save.png'),
      delProjectIcon: require('@/assets/images/ai-editor/icon-del.png'),
      publishProjectIcon: require('@/assets/images/ai-editor/icon-publish.png'),
      exitProjectIcon: require('@/assets/images/ai-editor/quit-edit.png'),
      projectTypeArr: [],
      emptyImgUrl: require('@/assets/images/datasetLobby/icon-empty-box.png'),
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'Train', 'userRole', 'editorTypeList']),
    totalCount() {
      return this.projectList.total ? this.projectList.total : 0
    },
    userId() {
      return this.$store.state.accountInfo.userId
    },
  },
  //监控data中的数据变化
  watch: {},
  created() {
    this.projectTypeArr = this.$store.state.projectTypeArr // 获取行业类型
    this.getDictTypeList()

    this.hasLogin = sessionStorage.getItem('hasLogin') == 'true' ? true : false
  },
  mounted() {
    let self = this
    bus.$on('getWorkspaceIsVisible', (workspaceIsVisible) => {
      self.workspaceIsVisible = workspaceIsVisible
    })
    //ai-T编辑器进来时，没有现成的项目，弹出新建项目弹框
    if (!this.projectId) {
      this.popupActive = 'openCreate'
      this.currentPage = 1
      this.projectList.size = 4
      this.GetPageList()
    }
  },
  beforeDestroy() {
    bus.$off('getWorkspaceIsVisible')
  },
  methods: {
    toDocPage() {
      window.open('/projects/robot/a/helpdocument')
    },
    async getDictTypeList() {
      let res = await this.getDataSetType('ProjectType')
      if (res && res.isSuccess) {
        this.dictTypeList = res.data
      }
    },
    // 弹窗tab：我的项目、创建项目 切换
    onPopupTabName(val) {
      this.popupTabName = val
    },
    // 弹窗-确认新建按钮
    onOpenCreate() {
      this.projectHandler()
    },
    // 取消弹窗
    cancelPopup() {
      if (this.popupActive === 'openCreate') {
        this.$emit('onExecution')
      } else {
        this.popupActive = ''
      }
    },

    exitProject(type) {
      bus.$emit('beforeLeave', type)
    },
    saveFile: debounce(function(type) {
      let { userId, Project } = this
      if (!userId || !Project) return
      if (userId !== Project.createBy && Project.proOperate === 1) {
        return this.$message.error('非本人创建的公开项目不能进行修改！')
      }
      if (!this.Project.projectName) {
        return this.$message.error('实训项目名称不能为空！')
      }
      this.$emit('saveFile')
    }, 500),
    headFileCommand(command) {
      this[command]()
    },
    // 修改实训项目名称
    editeProject() {
      let { projectId, Project } = this,
        projectName = Project.projectName,
        data = {}
      if (projectName) {
        projectName = projectName.trim()
      }
      if (!Project || !projectName) return
      data = {
        projectId,
        projectName,
        projectContent: Project.projectContent,
        projectType: Project.proType,
      }
      PERSONAL.updateProjectByProjectId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('项目编辑成功！')
        }
      })
      // this.$emit('editeProject',projectName);
    },
    // 打开
    activeOpenPopup() {
      this.popupActive = 'open'
      this.currentPage = 1
      this.projectList.size = 6
      this.GetPageList()
    },
    // 获取项目分页
    GetPageList(activePageIndex, type) {
      var pageIndex = activePageIndex
          ? activePageIndex
          : this.projectList.pageIndex
          ? this.projectList.pageIndex + 1
          : 1,
        pageSize = this.projectList.size ? this.projectList.size : 6,
        proOperate = type || this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          proOperate,
          userId,
          editorId,
          pageNum: pageIndex,
          pageSize: pageSize,
        }
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          if (type === 1) {
            //公开的项目列表
            this.Cases = result.data
          } else {
            //的项目列表
            this.projectList = result.data
            if (
              result.data &&
              result.data.records &&
              result.data.records.length > 0
            ) {
              this.popupTabName = 'myProjects'
            } else {
              this.popupTabName = 'newProjects'
            }
          }
        }
      })
    },
    // 搜索获取项目分页
    GetPageListByName(activePageIndex) {
      var pageIndex =
          typeof activePageIndex === 'number'
            ? activePageIndex
            : this.projectList.pageIndex
            ? this.projectList.pageIndex + 1
            : 1,
        pageSize = this.projectList.size ? this.projectList.size : 6,
        projectName = this.searchKey,
        proOperate = this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          proOperate,
          userId,
          pageNum: pageIndex,
          pageSize,
          editorId,
        }
      if (projectName) {
        data.projectName = projectName
      }
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          this.projectList = result.data
          this.pageStatus = 'search'
        }
      })
    },
    // 分页
    handleCurrentChange(pageIdx) {
      var pageStutas = this.pageStutas
      if (pageStutas === 'normal') {
        this.GetPageList(pageIdx)
      } else if (pageStutas === 'search') {
        this.GetPageListByName(pageIdx)
      }
    },
    activeSelectProject(project) {
      this.redirectToProject(project)
      this.reload()
    },
    // 跳转
    redirectToProject(project) {
      let editorId = this.editorId
      let editorTypeList = this.editorTypeList
      let queryName
      let editorName = editorTypeList.find((editor) => {
        return editorId === editor.dictId
      }).dictTypeDesc
      // debugger
      if (/小智/.test(editorName)) {
        queryName = 'hardwareBlock-editor-B'
      } else if (/小聪/.test(editorName)) {
        queryName = 'hardwareBlock-editor'
      }
      console.log('queryName', queryName)

      this.$router.push({
        name: queryName,
        query: {
          projectId: project.projectId,
          createBy: project.createBy,
          editorId,
        },
      })
      // this.reload();
      // window.location.reload(); // 切换项目清空状态，会让页面重新加载，体验感差
    },
    // 新建
    activeCreatePopup() {
      this.popupActive = 'create'
    },
    projectHandler() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (
            this.popupActive === 'create' ||
            this.popupActive === 'openCreate'
          ) {
            // 新建
            this.createNewProject()
          } else {
            // 另存为
            this.saveCopyProject()
          }
        } else {
          this.$message.error('请将项目相关内容填写完整')
        }
      })
    },
    createNewProject() {
      var projectName = this.NewProject.projectName,
        projectContent = this.NewProject.projectContent,
        proType = this.NewProject.proType,
        editorId = this.editorId,
        data
      // 项目命名不能为空和超出限制的字符长度
      if (this.$util.checkStrNullOrTooLong.call(this, [projectName])) {
        return
      }
      data = {
        projectName: projectName,
        projectContent: projectContent,
        projectType: proType,
        editorId,
      }
      PERSONAL.insertProjectByUserId(data).then((result) => {
        if (result.isSuccess) {
          this.redirectToProject(result.data)
          this.cancelPopup()
          this.reload()
          this.popupActive === ''
        } else {
          // 项目名称重复，重新输入名称。
          this.$message({
            message: result.returnMsg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    //另存为
    activeSaveCopyPopup() {
      this.popupActive = 'copy'
      this.NewProject.projectName = this.Project.projectName
      // this.NewProject.projectName = this.Project.projectName + "-另存为";
    },
    // 保存另存为操作
    saveCopyProject(runType) {
      var self = this,
        projectName = this.NewProject.projectName,
        projectContent = this.NewProject.projectContent,
        proType = this.NewProject.proType,
        runMode = runType ? runType : 'copy',
        editorId = this.editorId,
        data
      // 项目命名不能为空和超出限制的字符长度
      if (this.$util.checkStrNullOrTooLong.call(this, [projectName])) {
        return
      }

      data = {
        projectName: projectName,
        projectContent: projectContent,
        projectType: proType,
        editorId: editorId,
      }
      // 先创建，再保存文件，再次更新数据库
      // TODO:此处可以优化
      PERSONAL.insertProjectByUserId(data).then((result) => {
        if (result.isSuccess) {
          let Project = result.data
          let newProjectId = result.data.projectId
          // 以 copy 运行模式进行积木 XML 保存
          // 不同保存模式，弹窗提示~
          self.$emit('saveFile', newProjectId)
          // 将路由更新到新项目中
          self.redirectToProject(result.data)
          self.reload()
        } else {
          // 项目名称重复，重新输入名称。
          self.$message({
            message: result.returnMsg,
            type: 'error',
            duration: 2000,
          })

          self.activeRenamePopup() //重命名弹框???
        }
      })
    },

    // 项目案例到工作台
    caseToWorkspace(idx) {
      var ProjectCase = this.Cases[idx],
        ProjectName = ProjectCase.CaseName,
        xmlText = ProjectCase.xmlText

      // 创建一个新的 Project
      // TODO:利用项目 ID 全置 0 来做项目案例前期标记
      this.Project.ProjectId = this.Placeholder.ProjectId
      this.Project.ProjectName = ProjectName
      this.Project.BlocksFileUrl = null

      // 保存时候会用到
      this.NewProject.ProjectName = ProjectName

      // 打开 XML
      this.$refs.blockly.createBlocksByWorkspaceXML(xmlText, true)
      this.$refs.blockly.workspace.clear()
      this.$refs.blockly.textToWorkspace(xmlText)

      // 关闭弹窗
      this.cancelPopup()
    },

    // UI rating star
    UIRatingStarshow(idx, rate) {
      let result = ''
      if (rate - idx >= 1) {
        result = 'icon-star-entire'
      } else if (rate - idx >= 0.5) {
        result = 'icon-star-half'
      }
      return result
    },

    //保存到本地
    saveToLocal() {
      // TODO:保存到本地
      let xml = this.$parent.$refs.blocklyIndex.$refs.blockly.workspaceToDom(),
        xmlBlob = new Blob([xml.outerHTML], { type: 'text/xml;charset=utf-8' }),
        xmlBlobUrl = window.URL.createObjectURL(xmlBlob),
        aDom = document.createElement('a')

      // 保存到服务器
      this.saveFile(null)

      aDom.setAttribute('href', xmlBlobUrl)
      aDom.setAttribute('download', this.Project.projectName)
      aDom.click()
      window.URL.revokeObjectURL(xmlBlobUrl)
      aDom = null
    },
    // 项目案例
    activeProjectCase() {
      this.popupActive = 'case'
      this.currentPage = 1
      this.projectList.total = 0 // 清空上一次的总条数
      this.GetPageList(null, 1) // 值为1时公开;
    },
    //从本地打开
    openFromLocal() {
      // 打开本地文件
      // var btnOpenXml = document.getElementById("btnOpenXml");
      // btnOpenXml.click();
      let self = this
      var inputNode = document.createElement('input')
      inputNode.setAttribute('type', 'file') // 设置上传按钮属性
      inputNode.setAttribute('accept', 'text/xml')
      inputNode.click()
      inputNode.onchange = function(evt) {
        self.openLocalXml(evt)
      }
    },
    openLocalXml(evt) {
      // 获取 file
      let self = this,
        file = evt.target.files[0],
        reader = new FileReader() // 文件读取器 H5
      reader.onload = function loadReader(e) {
        var xmlText = e.target.result
        //调用BlocklyEditor.vue组件的方法
        self.$parent.$refs.blocklyIndex.$refs.blockly.createBlocksByWorkspaceXML(
          xmlText,
          true
        )
        self.$parent.$refs.blocklyIndex.$refs.blockly.textToWorkspace(xmlText)
      }

      reader.readAsText(file)
    },
    //从本地打开
    updateProject(event) {},
    changeMode() {
      bus.$emit('changeMode')
    },
    //账号设置跳转
    JumpSetting() {
      this.$router.push({ name: 'account-setting' })
    },
    //个人中心跳转6000
    JumpPersonal() {
      this.$router.push({ name: 'projects-list' })
    },
    //退出登录
    quitLogin() {
      var self = this
      self.hasLogin = false
      self.accountInfo.realName = ''
      self.accountInfo.roleNames = ''
      sessionStorage.setItem('hasLogin', '') //null,false,'',
      sessionStorage.token = ''
      self.$store.commit('userStatus', 'false')
      self.$router.push('/')
      localStorage.clear() //清除localStorage
      setTimeout(() => {
        bus.$emit('quit')
      }, 500)
    },
  }, //methods end
  updated() {},
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$head_height: 80px;
$font_size_nav: 15px;
$font_color_1st: #fff;
.un-active {
  opacity: 0.9;
}
.disPermit {
  opacity: 0.3;
  // pointer-events: none;
}
.training-head {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
  height: $head_height;
  padding: 0 20px;
  // background-image: linear-gradient(to right, #618aff, #8c6bf9);
  border-bottom: 2px solid rgba(74, 224, 226, 0.1);
  .head-title {
    // float: left;
    display: inline-block;
    box-sizing: border-box;
    width: 166px;
    height: 100%;
    font-size: $font_size_logo_title;
    font-weight: normal;
    line-height: $head_height;
    margin-right: 20px;
    // margin-right: 1.5%;
  }

  .head-title-img {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
  }
  .head-left {
    display: flex;
    align-items: center;
    white-space: nowrap;
    justify-content: space-between;
    width: calc(100% - 580px);

    .help {
      .help-icon {
        transform: scale(0.8);
      }
    }
  }
  .menu-list {
    display: flex;
  }
  .head-file {
    display: inline-block;
    height: 34px;
    padding-left: 7px;
    padding-right: 5px;
    line-height: 34px;
    margin-left: 20px;
    margin-right: 12px;
    margin-top: 4px;
    border: 1px solid transparent;
    border-image-slice: 1;
    box-sizing: border-box;
    font-size: 14px;
    transition: border linear 0.3s;
    // &:hover {
    //   // border: 1px solid #5777bb;
    //   // border-image: linear-gradient(to right, #678cff, rgba(103, 140, 255, 0.4));
    //   // background-image: linear-gradient(
    //   //   to right,
    //   //   rgba(103, 140, 255, 0.5),
    //   //   transparent
    //   // );
    //   // background-color: rgba(103, 140, 255, 0.2);
    // }
  }

  .head-edite-operate {
    // position: absolute;
    // left: 0;
    right: 0;
    width: 315px;
    // margin: 0 auto;
    // margin-left: 50px;
    white-space: nowrap;

    .training-name {
      display: inline-block;
      line-height: $head_height;
    }

    .el-input {
      line-height: 1;
      border: 1px solid transparent;
      // border-image-slice: 1;
      border-radius: 4px;
      box-sizing: border-box;

      &::v-deep .el-input__inner {
        width: 180px;
        border: 1px solid transparent;
        background-color: $background_input_switch;
        color: $background_popup_inner;
        transition: border 0.2s ease-in-out;
      }

      &:hover {
        // border-image: linear-gradient(to right, #678cff, transparent);
        // background-image: linear-gradient(
        //   to right,
        //   rgba(103, 140, 255, 0.5),
        //   transparent
        // );
        border-color: rgba(103, 140, 255, 0.6);
        background-color: rgba(103, 140, 255, 0.2);
      }
    }

    .training-switch {
      display: inline-block;
      width: 120px;
      border-radius: 20px;
      background-color: $background_input_switch;
      margin-left: 10px;
      text-align: center;

      .el-button {
        padding: 12px 10px;
        border: 1px solid transparent;
        background: transparent;
        color: $white;
        box-sizing: border-box;

        .icon_mode-code {
          margin-right: 10px;
          &::v-deep .cls-1 {
            fill: $white;
          }
        }

        & + .el-button {
          margin-left: 0;
        }
      }

      .switch-on {
        display: inline-block;
      }

      .switch-off {
        display: none;
      }

      &:hover {
        // background-image: linear-gradient(
        //   to right,
        //   rgba(103, 140, 255, 0.5),
        //   transparent
        // );
        // border-color: rgba(255, 255, 255, 0.85);
        background-color: rgba(103, 140, 255, 0.5);
      }
    }
    .help {
      display: inline-block;
      margin-left: 20px;
      transform: translateY(5px);
    }
  }

  .func-wrap {
    // width: 54%;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-right: 20px;
  }

  .head-item {
    font-size: $font_size_nav;
    color: $font_color_1st;

    .el-dropdown {
      margin-left: 5px;
      font-size: $font_size_nav;
      color: $font_color_1st;
      &.un-active {
        color: #666;
      }
      .el-dropdown-link {
        padding: 0.75em 0;

        .icon_nav-icon {
          margin-right: 6px;
        }
      }
    }
    &.head-save {
      vertical-align: middle;
      .icon-del-head {
        margin-right: 10px;
      }
    }

    &.el-button {
      // padding-left: 0;
      padding: 0.75em 0;
      border: none;
      background: transparent;
      .icon_nav-icon {
        margin-right: 6px !important;
      }

      &.el-popper {
        margin-top: 4px;
        margin-left: 140px;
      }
    }
    &.submit-and-score {
      padding: 12px 22px;
      border-radius: 20px;
      background: $background_input_switch;
      display: block;
      font-size: 15px;
      color: #fff;
      // &:hover{color:#fff;}
    }
    &.submit-unactive {
      // background: #999;
      // color: #666;
      opacity: 0.3;
    }
    &.has-scored {
      background: #4c88ff;
      color: #fff;

      // &:hover{color:#fff;}
    }
    .icon_nav-icon {
      // width: auto;
      height: 1em;
    }

    &.head-exit {
      .text {
        margin-left: 6px;
      }
    }
  }

  .head-right {
    display: flex;
    align-items: center;
    font-size: $font_size;
    position: absolute;
    right: 20px;
    height: 80px;
    .help {
      display: inline-block;
    }
    .run-btn {
      display: flex;
      align-items: center;
      margin: 0 10px;
      padding: 8px 20px;
      border-radius: 17px;
      background: rgba(52, 84, 164, 0.6);
      font-size: 14px;
      color: #fefeff;
      font-family: Microsoft YaHei;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: rgba(103, 140, 255, 0.6);
      }
      .text {
        margin-left: 10px;
      }
    }

    .col-line {
      display: inline-block;
      width: 1px;
      height: 2em;
      margin: 0 20px;
      background-color: $line_splite_col_color;
    }

    .userinfo {
      display: inline-block;

      .profile {
        display: inline-block;
        overflow: hidden;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        line-height: 24px;
        text-align: training-area;
        vertical-align: middle;

        > img {
          width: 100%;
          height: 100%;
        }
      }

      ::v-deep .el-dropdown {
        display: inline-block;
        margin-left: 10px;
        color: #fff;
        vertical-align: middle;
      }
      .header-name {
        display: inline-block;
        width: 70px;
        vertical-align: middle;
        font-size: 14px;
        margin-left: 5px;
      }
      .user-role {
        background: linear-gradient(to left, #367aff, #b15fff);
        font-size: 14px;
        margin-left: 5px;
        border-radius: 10px 10px 10px 0;
        padding: 5px 5px;
      }
    }
  }
}
.popup-list {
  .popup-open,
  .popup-copy,
  .popup-case,
  .popup-create {
    &.off {
      display: none;
    }
    &.on {
      display: inline-block;
    }
    z-index: 80;
  }
  .popup-create {
    &::v-deep .popup-inner {
      width: 480px;
      height: 400px;
      .popup-content {
        padding: 30px 30px 0 30px;

        .pop-select {
          width: 100%;
        }
      }
    }
  }

  .popup-case {
    &::v-deep .popup-head .title {
      color: $color_popup_title;
    }

    &::v-deep .popup-inner {
      width: 980px;
      height: 500px;
      max-height: 100%;
    }

    &::v-deep .popup-buttons {
      display: none;
    }

    .cases {
      overflow: auto;
      height: 460px;
      margin-top: 30px;
      display: table;
      display: flex;
      // justify-content: space-between;
      // MARK: 屏蔽滚动条
      flex-wrap: wrap;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;

      // &::-webkit-scrollbar {
      //   width: 0 !important;
      // }
    }
    .open-projects {
      overflow: auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // height: 360px;
      // MARK: 屏蔽滚动条
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      padding-top: 30px;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .open-projects-tips {
        color: rgb(145, 144, 144);
        width: 300px;
        height: 360px;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 134px;
          height: 80px;
        }
        span {
          color: #BDC3D2;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          margin-top: 16px;
        }
      }
    }
    .open-project {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      box-sizing: border-box;
      width: 450px;
      height: 90px;
      padding: 20px;
      border: 1px solid #dfe4f1;
      margin-bottom: 20px;
      cursor: pointer;
      .cover {
        width: 50px;
        min-width: 50px;
        height: 50px;
        min-height: 50px;
      }
      .title {
        flex: auto;
        margin: 0 20px;
      }
    }

    .case-item {
      // display: inline-block;
      width: 240px;
      height: 210px;
      margin: 0 0 20px 20px;
      color: $font_333_color;
      cursor: pointer;

      &:nth-of-type(4n + 1) {
        margin-left: 0;
      }

      .cover {
        overflow: hidden;
        width: 240px;
        height: 150px;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        padding: 15px 0 10px 0;
        font-size: $font_size_middle;
        line-height: 1;
        font-weight: normal;
      }
      .rate {
        display: flex;
        color: $font_gray_color;
        font-size: $font_size;

        .p-rate {
          margin-right: 10px;
        }
      }
      .icon-star {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 5px;
        background-image: url('../../../../assets/images/rate-star.png');
        background-position: 0 0;

        &.icon-star-half {
          background-position: -20px 0;
        }

        &.icon-star-entire {
          background-position: -40px 0;
        }
      }
    }
  }

  .popup-open {
    &::v-deep .popup-inner {
      width: 980px;
      // height: 800px;
      // max-height: 85%;
      height: 550px;
      max-height: 100%;
    }

    .open-tab-nav {
      height: 100%;
      .open-tab {
        display: inline-block;
        box-sizing: border-box;
        margin-left: 35px;
        border-bottom: 3px solid transparent;
        color: #333;
        line-height: 50px;
        cursor: pointer;

        &:first-child {
          margin-left: 0;
        }

        &.active {
          border-bottom-color: #4c88ff;
          color: #2b6ceb;
        }
      }
    }

    .open-content {
      .open-content-search {
        width: 450px;
        margin-bottom: 20px;

        .el-icon-search {
          cursor: pointer;
        }
      }

      .open-projects {
        overflow: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // height: 360px;
        // MARK: 屏蔽滚动条
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;

        &::-webkit-scrollbar {
          width: 0 !important;
        }

        .open-projects-tips {
          color: rgb(145, 144, 144);
          width: 300px;
          height: 340px;
          margin: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 134px;
            height: 80px;
          }
          span {
            color: #BDC3D2;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            margin-top: 16px;
          }
        }
      }

      .open-project {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        box-sizing: border-box;
        width: 450px;
        height: 90px;
        padding: 20px;
        border: 1px solid #dfe4f1;
        margin-bottom: 20px;
        cursor: pointer;

        .cover {
          width: 50px;
          min-width: 50px;
          height: 50px;
          min-height: 50px;
        }

        .title {
          flex: auto;
          margin: 0 20px;
        }
      }
    }
  }
  ::v-deep.pagination {
    padding: 10px 0;
  }
  ::v-deep.el-input .el-input__count {
    position: relative;
    top: 20%;
    right: 0.1em;
  }
  ::v-deeptextarea.el-textarea__inner {
    resize: none;
  }

  .popup-open-create {
    &::v-deep .popup-inner {
      // width: 980px;
      height: 450px;
      // max-height: 85%;
    }

    .pop-el-form {
      // width: 94%;
      background: #fff;
      // position: absolute;
      // left: 30px;
      // bottom: 30px;
      padding-top: 30px;
      .create-title {
        color: #2b6ceb;
        display: inline-block;
        font-size: 16px;
        border-bottom: 3px solid #2b6ceb;
      }
      .pop-select {
        width: 100%;
      }
      .el-form-item-button {
        text-align: center;
        margin-top: 100px;
      }
    }

    ::v-deep.el-divider--horizontal {
      width: 94%;
      position: absolute;
      left: 30px;
      bottom: 390px;
      margin: 0;
      z-index: 1;
    }
  }
}
</style>
